import orderBy from "lodash/orderBy";

import {Part} from "../part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {showerThumbnail} from '../../../bvComponent/core/assets';

// import store from "../../../../store";

import {ShowerTubCombo} from "./showerTubCombo";

import ShowerFixture from "../subparts/shower/showerFixture";
import ShowerScreen from "../subparts/shower/showerScreen";
import ShowerGlass from "../subparts/shower/showerGlass";
// import ShowerOverlay from "../subparts/shower/showerOverlay";
import ShowerBody from "../subparts/shower/showerBody";
import ShowerWall from "../subparts/shower/showerWall";
import ShowerWallAccent from "../subparts/shower/showerWallAccent";
import ShowerDoor from "../subparts/shower/showerDoor";
import ShowerPanCombo from "../subparts/shower/showerPanCombo";
import ShowerDoorHandle from "../subparts/shower/showerDoorHandle";
import PonyWallCap from "../subparts/shower/ponyWallCap";
import PonyWallGlass from "../subparts/shower/ponyWallGlass";
import ShowerFloor from "../subparts/shower/showerFloor";
import Threshold from "../subparts/shower/threshold";
import ShowerDrain from "../subparts/shower/showerDrain";
import ShowerHead from "../subparts/shower/showerHead";
import ShowerArm from "../subparts/shower/showerArm";
import ShowerHeadBundle from "../subparts/shower/showerHeadBundle";
import HandShowerKit from "../subparts/shower/handShowerKit";

import {ShowerHeadTypes, ShowerHandTypes} from "../constants";
import ShowerCurb from "../subparts/shower/showerCurb";
import BodySpray from "../subparts/showerNew/bodySpray";
import DiverterTrim from "../subparts/showerNew/diverterTrim";
import HandShowerHolder from "../subparts/showerNew/handShowerHolder";
import HandShowerOnly from "../subparts/showerNew/handShowerOnly";
import ShowerHose from "../subparts/showerNew/showerHose";
import ShowerSystem from "../subparts/showerNew/showerSystem";
import ShowerTrimKit from "../subparts/showerNew/showerTrimKit";
import ValveTrim from "../subparts/showerNew/valveTrim";
import WallUnion from "../subparts/showerNew/wallUnion";

export class Shower extends Part {
  static id = 'Shower';

  static Type = {
    Custom: 'Custom',
    Complete: 'Complete',
    Combo: 'Combo',
    All: 'All'
  };

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerThumbnail;
    this.partName = 'Shower';
    this.translateId = "visualizer.bathroom.shower";
    this.relatedItems = [];
    this.activeSubType_ = Shower.Type.Custom;

    this.customBodyType = 1; // Door

    this.showerBody = null;
    this.showerScreen = null;
    this.showerGlass = null;
    this.showerWall = null;
    this.showerWallAccent = null;

    // old
    this.showerFloor = null;
    this.showerOverlay = null;
    // old

    this.showerPanCombo = null;
    this.threshold = null;
    this.showerFixture = null;
    this.showerBodySelectedByUser = false;
    this.showerDoor = null;
    this.showerDoorHandle = null;

    this.ponyWallCap = null;
    this.ponyWallGlass = null;
    this.showerHead = null;
    this.showerArm = null;
    this.showerHeadBundle = null;
    this.handShowerKit = null;
    this.bodySpray = null;
    this.diverterTrim = null;
    this.handShowerHolder = null;
    this.handShowerOnly = null;
    this.showerHose = null;
    this.showerSystem = null;
    this.showerTrimKit = null;
    this.valveTrim = null;
    this.wallUnion = null;

    this.showerBody = new ShowerBody(true);
    this.showerBody.getParent = () => this;
    this.showerBody.type = Shower.Type.All;
    this.showerBody.counts = {
      allLayoutFeaturesCount: 0,
      largeLayoutFeaturesCount: 0,
      smallLayoutFeaturesCount: 0
    };
    this.relatedItems.push(this.showerBody);

    this.showerFloorIsActive = false;
    this.shower_head_type = ShowerHeadTypes.shower_fixture;
    this.shower_hand_type = ShowerHandTypes.hand_shower_holder;
    this.relatedGroupNames = ["Shower Pan", "Shower Wall", "Shower Wall Accent", "Shower Door", "Shower Door Handle",
      "ShowerPan", "ShowerFloor", "Shower Fixture", "Shower Drain", "Shower Head", "Shower Arm", "Shower Head Bundle",
      "Pony Wall Cap", "Pony Wall Glass", "Shower Screen", "Shower Glass", "Shower Body", "Hand Shower Kit",
      "Shower Curb", "Body Spray", "Diverter Trim", "Hand Shower Holder", "Hand Shower Only", "Shower Hose",
      "Shower System", "Shower Trim Kit", "Valve Trim", "Wall Union"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      relatedItemType = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Shower Pan":
      case "Shower Pans":
        relatedItemName = "showerPanCombo";
        RelatedItemClass = ShowerPanCombo;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Wall":
        relatedItemName = "showerWall";
        RelatedItemClass = ShowerWall;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Wall Accent":
        relatedItemName = "showerWallAccent";
        RelatedItemClass = ShowerWallAccent;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Door":
      case "Shower_Door":
        relatedItemName = "showerDoor";
        RelatedItemClass = ShowerDoor;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Door Handle":
        relatedItemName = "showerDoorHandle";
        RelatedItemClass = ShowerDoorHandle;
        relatedItemType = Shower.Type.Custom;
        break;
      case "ShowerPan":
        relatedItemName = "threshold";
        RelatedItemClass = Threshold;
        relatedItemType = Shower.Type.Custom;
        break;
      case "ShowerFloor":
      case "Shower Floor":
        relatedItemName = "showerFloor";
        RelatedItemClass = ShowerFloor;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Fixture":
        relatedItemName = "showerFixture";
        RelatedItemClass = ShowerFixture;
        relatedItemType = Shower.Type.All;
        break;
      case "Shower Drain":
        relatedItemName = "showerDrain";
        RelatedItemClass = ShowerDrain;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Head":
        relatedItemName = "showerHead";
        RelatedItemClass = ShowerHead;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Arm":
        relatedItemName = "showerArm";
        RelatedItemClass = ShowerArm;
        relatedItemType = Shower.Type.All;
        break;
      case "Shower Head Bundle":
        relatedItemName = "showerHeadBundle";
        RelatedItemClass = ShowerHeadBundle;
        relatedItemType = Shower.Type.All;
        break;
      case "Pony Wall Cap":
        relatedItemName = "ponyWallCap";
        RelatedItemClass = PonyWallCap;
        relatedItemType = Shower.Type.All;
        break;
      case "Pony Wall Glass":
        relatedItemName = "ponyWallGlass";
        RelatedItemClass = PonyWallGlass;
        relatedItemType = Shower.Type.All;
        break;
      case "Shower Screen":
        relatedItemName = "showerScreen";
        RelatedItemClass = ShowerScreen;
        relatedItemType = Shower.Type.All;
        break;
      case "Shower Glass":
        if (!this.showerBody) {
          this.showerBody = new ShowerBody(true);
          this.relatedItems.push(this.showerBody);
        }
        relatedItemName = "showerGlass";
        RelatedItemClass = ShowerGlass;
        relatedItemType = Shower.Type.All;
        break;
      // case "Shower Overlay":
      //   relatedItemName = "showerOverlay";
      //   RelatedItemClass = ShowerOverlay;
      //   relatedItemType = Shower.Type.Custom;
      //   break;
      case "Shower Body":
        relatedItemName = "showerBody";
        RelatedItemClass = ShowerBody;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Hand Shower Kit":
        relatedItemName = "handShowerKit";
        RelatedItemClass = HandShowerKit;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Curb":
        relatedItemName = "showerCurb";
        RelatedItemClass = ShowerCurb;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Body Spray":
        relatedItemName = "bodySpray";
        RelatedItemClass = BodySpray;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Diverter Trim":
      case "Diverter Only Trim":
        relatedItemName = "diverterTrim";
        RelatedItemClass = DiverterTrim;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Hand Shower Holder":
        relatedItemName = "handShowerHolder";
        RelatedItemClass = HandShowerHolder;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Hand Shower Only":
        relatedItemName = "handShowerOnly";
        RelatedItemClass = HandShowerOnly;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Hose":
        relatedItemName = "showerHose";
        RelatedItemClass = ShowerHose;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower System":
        relatedItemName = "showerSystem";
        RelatedItemClass = ShowerSystem;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Shower Trim Kit":
        relatedItemName = "showerTrimKit";
        RelatedItemClass = ShowerTrimKit;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Valve Trim":
        relatedItemName = "valveTrim";
        RelatedItemClass = ValveTrim;
        relatedItemType = Shower.Type.Custom;
        break;
      case "Wall Union":
        relatedItemName = "wallUnion";
        RelatedItemClass = WallUnion;
        relatedItemType = Shower.Type.Custom;
        break;

    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].type = relatedItemType;
      if (loadFeature) {
        this[relatedItemName].load(dbFeature);
      }
      return true
    }
    return false
  }

  setSpecificRules() {}

  // setLayers(layout, placeholdersNeeded) {
  //   let res = [];
  //   const relatedItems = this.getRelatedItems();
  //   // console.log('relatedItems', relatedItems);
  //   relatedItems.forEach(relatedItem => {
  //     relatedItem.setLayers(layout);
  //   });
  //   if (this.showerDoor && !this.showerDoor.activeFeature) {  // we need it cause shower door is relying on shPanCombo
  //     this.showerDoor.setLayers(layout);
  //   }
  //   if (this.showerDoorHandle && !this.showerDoorHandle.activeFeature) {
  //     this.showerDoorHandle.setLayers(layout);
  //   }
  //   relatedItems.forEach(relatedItem => {
  //
  //     (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
  //       ? relatedItem.placeholderFeature.layer.addTo(res)
  //       : relatedItem.activeFeature && relatedItem.activeFeature.layer ? relatedItem.activeFeature.layer.addTo(res) : null
  //
  //     // NN(relatedItem.activeFeature, (activeFeature) => activeFeature.layer.addTo(res));
  //
  //     if ((relatedItem instanceof ShowerBody || relatedItem instanceof ShowerInteriorWallAccent)
  //       && relatedItem.activeFeatureParts && relatedItem.activeFeatureParts.length) {
  //       relatedItem.activeFeatureParts.forEach((activeFeaturePart) => {
  //         activeFeaturePart && !activeFeaturePart.disabled && activeFeaturePart.layer && activeFeaturePart.layer.addTo(res);
  //       })
  //     }
  //     if (relatedItem instanceof ShowerWall && relatedItem.activeFeatureParts && relatedItem.placeholderChanged && relatedItem.activeFeatureParts.length) {
  //       relatedItem.activeFeatureParts.forEach((activeFeaturePart) => {
  //         activeFeaturePart && !activeFeaturePart.disabled && activeFeaturePart.layer && activeFeaturePart.layer.addTo(res);
  //       })
  //     }
  //
  //   });
  //
  //   return res.length ? res : null;
  // }

  subTypes() {
    return this.showerBody && (this.showerBody.features.some(showerBodyFeature => showerBodyFeature.type === 0)
      && this.showerBody.features.some(showerBodyFeature => showerBodyFeature.type === 1)) ? [
      Shower.Type.Custom,
      Shower.Type.Complete,
    ] : []
  }

  isSubTypeWithItems() {
    return true;
  }

  activeSubType() {
    return this.activeSubType_;
  }

  handleSubTypeClick(subType, handleNavigationItemClick) {
    this.activeSubType_ = subType;
    this.showerBody.setDefault();   // set default custom shower
    if (handleNavigationItemClick) {
      handleNavigationItemClick(this.showerBody.navigationSubItems()[0]) // set default custom shower
    }
  }

  getRelatedItems() {
    const relatedItems = orderBy(this.relatedItems, 'layerPriority');
    if (this.showerTubComboIsActive()) {
      return relatedItems
    }
    return relatedItems.filter((relatedItem) => {
      return relatedItem.type === this.activeSubType_ || relatedItem.type === Shower.Type.All
    })
  }

  subParts() {
    // const activeShowerGroup = this.getActiveShowerGroup();
    // const ponyWallIsActive = activeShowerGroup.showerDimensions() === "Pony";
    return this.getRelatedItems()
      .filter(item => {
        // if (item.isPonyWallPart) {
        //   item.visible = ponyWallIsActive
        // }
        return item.visible
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
    // return filter(this.relatedItems, {visible: true}).map(_ => new DesignNavigationItem(_.partName, _));
  }

  //
  // toggleShowerParts(disabled, keepLeftWall) {
  //   this.getRelatedItems().forEach((relItem) => {
  //     console.log('relItem', relItem);
  //     if (
  //       relItem.partId !== "shower_wall"
  //       && relItem.partId !== "shower_wall_accent"
  //       && relItem.partId !== "shower_fixture"
  //       && relItem.partId !== "shower_door"
  //       && relItem.partId !== "shower_door_handle"
  //       && relItem.partId !== "pony_wall"
  //       && relItem.partId !== "pony_wall_cap"
  //       && relItem.partId !== "pony_wall_glass"
  //     ) {
  //       relItem.disabled = disabled;
  //     }
  //   });
  //   if (!keepLeftWall) {
  //     this.layout.parts.Walls.wallExL.disabled = disabled;
  //   }
  // }

  setDefault(layout) {
    const relatedItems = orderBy(this.relatedItems, 'layerPriority');
    relatedItems.forEach(_ => _.setDefault(layout));
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  handleSubPartClick() {

  }

  /**
   * Gets the current shower size from metaValues.
   */
  showerSize() {
    if (this.showerTubComboIsActive()) {
      const showerTubCombo = this.getActiveShowerGroup();
      if (showerTubCombo) {
        const activeRelItem = showerTubCombo.relatedItems.find(featureGroup => featureGroup.partId === showerTubCombo.bottomTub)
          || showerTubCombo.replacementTub;
        if (activeRelItem && activeRelItem.activeFeature && activeRelItem.activeFeature.metaData["ShowerSize"]) {
          return activeRelItem.activeFeature.metaData["ShowerSize"][0]
        }
      }
      return null
    }
    if (this.showerPanCombo && this.showerPanCombo.activeFeature && this.showerPanCombo.activeFeature.metaData["ShowerSize"]
      && this.showerPanCombo.activeFeature.matchesMetaForArrayOfConditions(this.showerPanCombo.getArrayOfConditions())) {
      return this.showerPanCombo.activeFeature.metaData["ShowerSize"][0]
    }
    return null
  }

  /**
   * Gets the current shower dimensions from showerBody
   */
  showerDimensions() {
    if (!this.showerBody)
      return "Full";
    return this.showerBody.activeFeature ? this.showerBody.activeFeature.showerDimensions : null;
    // "Full" : "Half";
  }

  isComplete() {
    if (!this.showerBody) {
      return true;
    } else if (this.showerTubComboIsActive()) {
      return false;
    } else {
      return this.showerBody.activeFeature
    }
  }

  showerTubComboIsActive() {
    const comboPart = this.layout.parts[ShowerTubCombo.id];
    return comboPart && comboPart.showerTubComboIsActive
  }

  getActiveShowerGroup() {  // user for taking sizes, etc...
    return this.showerTubComboIsActive() ? this.layout.parts[ShowerTubCombo.id] : this;
  }

  setShowerHeadType(showerHeadType, fromPartId = "") {
    this.shower_head_type = showerHeadType;

    let arrayToDisable = [];
    let arrayToEnable = [];
    switch (showerHeadType) {
      case ShowerHeadTypes.shower_head_bundle:
        arrayToDisable = [this.showerArm, this.showerHead, this.showerFixture, this.showerTrimKit, this.showerSystem];
        arrayToEnable = [this.showerHeadBundle];
        break;
      case ShowerHeadTypes.shower_arm:
        switch (fromPartId) {
          case "shower_arm":
          case "shower_head":
            // arrayToEnable = [this.showerArm, this.showerHead, this.valveTrim];
            // removed as we go through the wizard and should apply different colors
            arrayToEnable = [this.showerArm, this.showerHead];
            break;
          case "shower_hose":
          case "wall_union":
          case "hand_shower_only":
          case "hand_shower_holder":
            arrayToEnable = [this.handShowerHolder, this.handShowerOnly, this.wallUnion, this.showerHose];
            break;
          default:
            arrayToEnable = [this.showerArm, this.showerHead, this.wallUnion];
            break;
        }
        arrayToDisable = [this.showerHeadBundle, this.showerFixture, this.showerTrimKit, this.showerSystem];
        break;
      case ShowerHeadTypes.shower_trim_kit:
        arrayToDisable = [this.showerArm, this.showerHead, this.showerFixture, this.showerHeadBundle, this.showerSystem, this.wallUnion];
        arrayToEnable = [this.valveTrim, this.showerTrimKit];
        break;
      case ShowerHeadTypes.shower_system:
        arrayToDisable = [this.showerArm, this.showerHead, this.showerFixture, this.showerHeadBundle, this.showerTrimKit, this.wallUnion];
        arrayToEnable = [this.showerSystem];
        break;
      case ShowerHeadTypes.shower_fixture:
        arrayToDisable = [this.showerArm, this.showerHead, this.showerHeadBundle, this.showerTrimKit, this.wallUnion, this.showerHose, this.handShowerOnly, this.handShowerHolder];
        arrayToEnable = [this.showerFixture];
        break;
      default:
        break;
    }
    arrayToDisable.forEach(featureGroup => {
      if (featureGroup && !featureGroup.disabled) {
        featureGroup.disabled = true;
      }
    });
    arrayToEnable.forEach(featureGroup => {
      if (featureGroup && featureGroup.disabled && featureGroup.canBeEnabled()) {
        featureGroup.disabled = false;
      }
    });

  }

  setShowerHandType(showerType) {
    this.shower_hand_type = showerType;

    let arrayToDisable = [];
    let arrayToEnable = [];
    switch (showerType) {
      case ShowerHandTypes.hand_shower_kit:
        arrayToDisable = [this.handShowerHolder, this.handShowerOnly, this.showerHose];
        arrayToEnable = [this.handShowerKit];
        break;
      case ShowerHandTypes.hand_shower_holder:
        arrayToDisable = [this.handShowerKit];
        arrayToEnable = [this.handShowerHolder, this.handShowerOnly, this.showerHose];
        break;
      default:
        break;
    }
    arrayToDisable.forEach(featureGroup => {
      if (featureGroup && !featureGroup.disabled) {
        featureGroup.disabled = true;
      }
    });
    arrayToEnable.forEach(featureGroup => {
      if (featureGroup && featureGroup.disabled && featureGroup.canBeEnabled()) {
        featureGroup.disabled = false;
      }
    });

  }
}

